import { render, staticRenderFns } from "./CategorySearchResult.vue?vue&type=template&id=843a9c0c"
import script from "./CategorySearchResult.vue?vue&type=script&lang=js"
export * from "./CategorySearchResult.vue?vue&type=script&lang=js"
import style0 from "./CategorySearchResult.vue?vue&type=style&index=0&id=843a9c0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.41_css-loader@6.11.0_webpack@5.111.1_clean-css_0549c180fdd4db5a4b383db959df1d56/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports